import type { FunctionComponent } from 'react';

import './style.scss';

export const IconPending: FunctionComponent = () => (
  <div styleName="container">
    ●
  </div>
);
